import {
  windowChangeEmitter
} from "@/utils/emitter";
import {
  defineComponent,
  reactive,
  ref,
  onMounted,
  toRefs,
  watch,
  
} from "vue";
import store from "@/store";
import {
  nextTick
} from "vue";
let DIFF = 82;
const searchWidth = 190;
export default function () {
  const state = reactive({
    tableHeight: 0,
    listQueryFormWidth: 0,
    showCollapsed: false,
    firstTop: 0,
    lastTop: 0,
    listQueryWidth: 0,
    ifIsSignleRow: false,
    count: 0,
    diff: 0,
    calTopIndex: 0,
    top: 0,
    param: {
      class: "responsive-table"
    },
  });

  const tableHeightFilter = async (h) => {
    let top = await getTableTop();
    state.calTopIndex = 0;
    // console.log('tableHeightFilter top',top)
    return top;
  };

  const sleep = (diff) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(null);
      }, diff);
    });
  };
  const getTableTop = async () => {
    state.calTopIndex++;
    if (state.calTopIndex > 5) {
      return 0;
    }
    let top = 0;
    let tmp = document.getElementsByClassName(state.param.class)[0];
    // console.log('tmp',tmp,tmp?.getBoundingClientRect())
    if (tmp) {
      top = tmp.getBoundingClientRect().top;
      if (top === 0) {
        await sleep(20);
        top = await getTableTop();
      }
    } else {
      await sleep(20);
      top = await getTableTop();
    }
    return top;
  };
  const calQueryWidth = async () => {
      let tmp = document.getElementsByClassName("list-query-header-form");
      let rightWidth = store.state.user.windowSize.rightWidth;
      let formWidth = rightWidth - 64;
      if (tmp) {
        let form = tmp[0];
        if (form) {
          let items = document.getElementsByClassName("form-item-div")[0];
          if (items?.children) {
            let tmpArr = Array.from(items.children);
            let _t = 0;
            tmpArr.forEach((o) => {
              let cls = o.getAttribute("class") || "";
              if (cls.indexOf("list-query-header-search") < 0) {
                let t = o.getBoundingClientRect().width || 0;
                _t += t;
              }
            });
            await setFistLastTop();
            if (state.firstTop === state.lastTop) {
              let f = store.state.user.windowSize.rightWidth - 64;
              let m = searchWidth + _t - 3;
              if (f < m) {
                state.ifIsSignleRow = true;
                state.showCollapsed = true;
              } else {
                state.ifIsSignleRow = false;
              }
            } else {
              state.ifIsSignleRow = false;
            }
          }
        }
      }
  };
  // watch(()=>state.ifIsSignleRow,(n,o)=>{
  //   console.log(n,o)
  //   // debugger
  // })
  const setFistLastTop = async () => {
    let items = document.getElementsByClassName("form-item-div")[0];
    if (items?.children) {
      let tmpArr = Array.from(items.children);
      let first = tmpArr[0];
      let last = tmpArr[tmpArr.length - 1];

      state.firstTop = first.getBoundingClientRect().top;
      state.lastTop = last.getBoundingClientRect().top;
      console.log(items, first.getBoundingClientRect(), ".>>>><MM<<M");
      if (state.firstTop < state.lastTop) {
        state.showCollapsed = true;
      } else {
        state.showCollapsed = false;
      }
      // console.log('firstTop',state.firstTop,'lastTop',state.lastTop,state.showCollapsed)
    }
  };
  const getListQueryFormWidth = async () => {
    let tmp = document.getElementsByClassName("list-query-header-form");
    let rightWidth = store.state.user.windowSize.rightWidth;
    let formWidth = rightWidth - 64;
    if (tmp) {
      let form = tmp[0];
      if (form) {
        //let search = document.getElementsByClassName("list-query-header-search")[0]
        // if(search){
        //   searchWidth = search.getBoundingClientRect().width;
        // }
        if (rightWidth == 0) {
          await sleep(20);
          await getListQueryFormWidth();
        } else {
          console.log('formWidth',formWidth)
          state.listQueryFormWidth = formWidth - searchWidth;
          if (state.listQueryFormWidth < 0) {
            state.listQueryFormWidth = 0;
          }
        }
      }
    }
  };
  const tableHeightFn = async (height) => {
    let top = await tableHeightFilter(height);
    let tmp = height - top - DIFF;
    if (tmp <= 0) {
      tmp = DIFF;
    }
    state.tableHeight = tmp;
    state.top = top;
    console.log("原始高度", height - top - DIFF, height, tmp, top, DIFF);
    return tmp;
  };
  const setTableHeight = async (param) => {
    // state.diff = diff
    let diff = 0;
    if (typeof param === "object") {
      diff = param.diff || 0;
      state.param = param;
    } else if (typeof param === "number") {
      diff = param;
    }
    if (diff > 0) {
      DIFF = diff;
    } else {
      DIFF = 82;
    }
    let height = store.state.user.windowSize.height;
    if (!height) {
      height = window.innerHeight;
    }
    // console.log('height',height)
    await tableHeightFn(height);
    windowChangeEmitter.on("window-change", async (size) => {
      if (size) {
        await tableHeightFn(size.height);
      }
    });
  };
  const initQueryTableHeight = async (diff = 0) => {
    nextTick(async function () {
      await getListQueryFormWidth();
      setTimeout(async () => {
        await calQueryWidth();
      }, 1000)
      await setTableHeight(diff);
    })
  };

  const toggle = async () => {
    //  state.tableHeight = state.tableHeight - 42
      await calQueryWidth();
      await getListQueryFormWidth();
      await setTableHeight(state.diff);
    // console.log("state.ifIsSignleRow,",state.ifIsSignleRow)
  };
  return {
    ...toRefs(state),
    setTableHeight,
    calQueryWidth,
    toggle,
    initQueryTableHeight,
    diff: DIFF,
  };
}